import { render, staticRenderFns } from "./TitreEtAccroche.vue?vue&type=template&id=13488908&"
import script from "./TitreEtAccroche.vue?vue&type=script&lang=js&"
export * from "./TitreEtAccroche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports